import { useMutation } from '@tanstack/react-query';
import { createContact } from '../api/contact';
import { Contact } from '../interface/contact';
import { toast } from 'react-toastify';
export const useContact = () => {
  return useMutation<Contact, Error, Contact>({
    mutationFn: createContact,
    onSuccess: () => {
      return true;
    },
    onError: () => {
      toast.error('Đăng ký thất bại', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return Error;
    },
  });
};
